<template>
    <div class="containerInner">
        <div class="listHeader">
            <div class="headerLeftMenu">
                <span>表示条件</span>
                <template v-if="privateAdTabActive == 1">
                    <span>
                        <input class="searchInputText" type="text" :placeholder="computedPlaceholder"
                            v-model="searchKeyword" @keydown="enterSearch">
                    </span>
                </template>

                <span>
                    <select v-model="searchServiceId">
                        <option value="">全店舗</option>
                        <option v-for="service in filteredService()" :value="service.id" v-bind:key="service.id">
                            （{{ service.id }}）{{ service.name }}</option>
                    </select>
                </span>

                <span v-if="privateAdTabActive == 0">
                    <Datepicker class="datepicker" :maximumView="'month'" :minimumView="'month'" format="yyyy-MM"
                        v-model="firstDateOfthisMonth" :language="ja" placeholder="配信開始日" />
                </span>

                <span>
                    <a class="btn searchBtn" @click="searchItem">検索</a>
                </span>

                <span>
                    <a class="btn clearBtn" @click="searchClear">条件クリア</a>
                </span>
            </div>
            <div class="headerRightMenu">
                <template v-if="privateAdTabActive == 0">
                    <Button @click="openCreateCrmModal" class="ml10">新規追加</Button>
                </template>

                <template v-if="privateAdTabActive == 1">
                    <Button @click="openCreateEventModal" class="ml10">新規追加</Button>
                </template>
            </div>
        </div>


        <div class="mallAdWrapper">
            <div class="mallAdTab">
                <button class="mallAdTabBtn" v-bind:class="{ 'active': privateAdTabActive == 0 }"
                    @click="showCrmCost">CRM広告費</button>
                <button class="mallAdTabBtn" v-bind:class="{ 'active': privateAdTabActive == 1 }"
                    @click="showEvent">公式イベント</button>
            </div>
            <div class="table-container">
                <table id="MallAdTable">
                    <thead>
                        <tr v-if="privateAdTabActive == 0">
                            <th class="th_sticky_1">店舗</th>
                            <th class="th_sticky_2">配信開始日</th>
                            <th class="th_sticky_3">配信終了日</th>
                            <th>配信対象商品</th>
                            <th>広告費</th>
                        </tr>

                        <tr v-if="privateAdTabActive == 1">
                            <th class="th_sticky_1">店舗</th>
                            <th>開始日時</th>
                            <th>終了日時</th>
                            <th>イベント名</th>
                        </tr>
                    </thead>
                    <tbody class="selectRoasRow">
                        <template v-if="privateAdTabActive == 0">
                            <tr v-for="item in this.ads" :key="item['id']" @click="openEditCrmModal(item['id'])">
                                <td class="td_sticky_1">（{{ item['service_id'] }}）{{ item['service_name'] }}</td>
                                <td class="td_sticky_2">{{ item['start_date'] }}</td>
                                <td class="td_sticky_3">{{ item['end_date'] }}</td>
                                <td>{{ productNames(item['products']) }}</td>
                                <td class="price">{{ item['cost'] | priceLocaleString }}</td>
                            </tr>
                        </template>

                        <template v-if="privateAdTabActive == 1">
                            <tr v-for="item in this.ads" :key="item['id']" @click="openEditEventModal(item['id'])">
                                <td class="td_sticky_1">（{{ item['service_id'] }}）{{ item['service_name'] }}</td>
                                <td>{{ item['start_day'] + ' ' + item['start_time'] }}</td>
                                <td>{{ item['end_day'] + ' ' + item['end_time'] }}</td>
                                <td>{{ item['event_name'] }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>

        </div>

        <modal name="crmAdModal" :draggable="false" :resizable="false" width="60%" height="75%">
            <PrivateCrmAdModal :adId="this.selectedId" :createMode="this.createMode"
                @modalClosed="modalClosed('crmAdModal')" />
        </modal>

        <modal name="eventModal" :draggable="false" :resizable="false" width="70%" height="60%">
            <EventModal :eventId="this.selectedId" :createMode="this.createMode"
                @modalClosed="modalClosed('eventModal')" />
        </modal>

        <div class="loading-window" v-show="this.$store.state.loading">
            <div class="loading-window-inner">
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>
    </div>
</template>

<script>


import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import PrivateCrmAdModal from '../components/PrivateCrmAdModal.vue';
import EventModal from '../components/EventModal.vue';

export default {
    name: 'PrivateAd',
    data() {
        return {
            privateAdTabActive: 0,
            ads: [],
            createMode: false,
            selectedId: null,
            services: {},
            searchKeyword: "",
            searchServiceId: "",
            ja: ja,
            firstDateOfthisMonth: null,
        }
    },
    components: {
        Datepicker,
        PrivateCrmAdModal,
        EventModal,
    },
    mounted: function () {
        //初回表示は「CRM広告費」
        this.fetchCrmAds();

        //サービス名プルダウンセット
        this.getServiceId();
    },
    methods: {
        //テーブル固定部分の位置
        setStickyPositions() {
            const th1_stickyElement = this.$el.querySelector(".th_sticky_1");
            const th1_offsetwidth = th1_stickyElement.getBoundingClientRect().width;

            const th2_stickyElement = this.$el.querySelector(".th_sticky_2");
            const th2_offsetwidth = th2_stickyElement.getBoundingClientRect().width;

            th2_stickyElement.style.left = `${th1_offsetwidth}px`;

            const td2_stickyElements = this.$el.querySelectorAll(".td_sticky_2");
            td2_stickyElements.forEach(stickyElement => {
                stickyElement.style.left = `${th1_offsetwidth}px`;
            });


            const th3_offsetleft = parseFloat(th1_offsetwidth) + parseFloat(th2_offsetwidth);


            const th3_stickyElement = this.$el.querySelector(".th_sticky_3");
            th3_stickyElement.style.left = `${th3_offsetleft}px`;

            const td3_stickyElements = this.$el.querySelectorAll(".td_sticky_3");
            td3_stickyElements.forEach(stickyElement => {
                stickyElement.style.left = `${th3_offsetleft}px`;
            });
        },
        //CRM広告費新規追加
        openCreateCrmModal: function () {
            this.selectedId = null;
            this.createMode = true;
            this.$modal.show('crmAdModal');
        },
        //公式イベント新規追加
        openCreateEventModal: function () {
            this.selectedId = null;
            this.createMode = true;
            this.$modal.show('eventModal');
        },
        //CRM広告費編集
        openEditCrmModal: function (productId) {
            this.selectedId = productId;
            this.createMode = false;
            this.$modal.show('crmAdModal');
        },
        //公式イベント編集
        openEditEventModal: function (eventId) {
            this.selectedId = eventId;
            this.createMode = false;
            this.$modal.show('eventModal');
        },
        //CRM広告費登録内容取得
        fetchCrmAds: function () {
            this.$store.dispatch("loading", true);
            var url = "/api/privateCrmAds/";
            this.axios.get(url)
                .then((res) => {
                    this.ads = [...res.data];
                }).catch(() => {
                }).finally(() => {
                    this.$nextTick(() => {
                        this.setStickyPositions();
                    });
                    this.$store.dispatch("loading", false);
                });
        },
        //公式イベント登録内容取得
        fetchEvents: function () {
            this.$store.dispatch("loading", true);
            var url = "/api/officialEvents/";
            this.axios.get(url)
                .then((res) => {
                    this.ads = [...res.data];
                }).catch(() => {
                }).finally(() => {
                    this.$nextTick(() => {
                        this.setStickyPositions();
                    });
                    this.$store.dispatch("loading", false);
                });
        },
        //検索
        searchItem: function () {
            this.$store.dispatch("loading", true);
            this.currentPage = 1;

            //CRM広告費
            if (this.privateAdTabActive == 0) {
                var month = null;

                if (this.firstDateOfthisMonth != null) {
                    month = (this.firstDateOfthisMonth.getFullYear()) + '-' + (this.firstDateOfthisMonth.getMonth() + 1);
                }

                this.axios.get("/api/privateCrmAds/?page=1", { params: { searchServiceId: this.searchServiceId, searchStartDate: month } })
                    .then((res) => {
                        this.ads = [...res.data];
                    }).catch(() => {
                    }).finally(() => {
                        this.$nextTick(() => {
                            this.setStickyPositions();
                        });
                        this.$store.dispatch("loading", false);
                    });
            }

            //公式イベント
            else if (this.privateAdTabActive == 1) {
                this.axios.get("/api/officialEvents/?page=1", { params: { searchServiceId: this.searchServiceId, searchWords: this.searchKeyword } })
                    .then((res) => {
                        this.ads = [...res.data];
                    }).catch(() => {
                    }).finally(() => {
                        this.$nextTick(() => {
                            this.setStickyPositions();
                        });
                        this.$store.dispatch("loading", false);
                    });
            }
        },
        //条件クリア
        searchClear: function () {
            this.searchKeyword = "";
            this.searchServiceId = "";
            this.firstDateOfthisMonth = null;
        },
        // エンターキーが押された時に文字列検索を実行
        enterSearch: function (e) {
            if (e.keyCode == 13) {
                this.searchItem();
            }
        },
        //CRM広告費タブがクリックされた場合
        showCrmCost: function () {
            this.privateAdTabActive = 0;
            this.ads = [];
            this.searchKeyword = "";
            this.searchServiceId = "";
            this.fetchCrmAds();
        },
        //公式イベントタブがクリックされた場合
        showEvent: function () {
            this.privateAdTabActive = 1;
            this.ads = [];
            this.searchKeyword = "";
            this.searchServiceId = "";
            this.fetchEvents();
        },
        //モーダル閉じる
        modalClosed(modalName) {
            if (this.privateAdTabActive == 0) {
                this.fetchCrmAds();
            }
            if (this.privateAdTabActive == 1) {
                this.fetchEvents();
            }
            this.$modal.hide(modalName)
        },
        //商品名成形
        productNames: function (product_list) {
            var name = "";
            for (var product of product_list) {
                if (product["id"] == -1) {
                    name += "【0】全商品"
                }
                else {
                    name += "【" + product["id"] + "】" + product["name"];
                }
            }
            return name;
        },
        //サービスIDの一覧取得
        getServiceId: function () {
            this.axios.get("/api/service/")
                .then((res) => {
                    this.services = res.data;
                }).catch(() => {
                }).finally(() => {
                });
        },
        filteredService() {
            let result = [];
            let list = [30, 35];

            for (var idx in this.services) {
                let service = this.services[idx];
                if (list.includes(service.id)) {
                    result.push(service);
                }
            }
            return result;
        },
    },
    computed: {
        computedPlaceholder() {
            if (this.privateAdTabActive == 1) {
                return 'イベント名';
            } else {
                return ''; // デフォルト値（必要に応じて変更）
            }
        },
    }
}
</script>

<style scoped lang="sass">
.containerInner
    overflow: hidden
    .loading-window
        background: rgba(255, 255, 255, 0.8)
        height: 100%
        left: 0
        position: absolute
        top: 0px
        width: 100vw
        z-index: 1000
        .loading-window-inner
            left: 50%
            position: absolute
            text-align: center
            top: 50%
            transform: translate(-50%, -50%)
            z-index: 1000
            p
                font-size: 2.5rem
                margin-bottom: 40px
    .listHeader
        color: $grayColor
        display: flex
        font-size: 1.4rem
        margin: 20px 140px 0 140px
        padding: 10px 0
        .headerLeftMenu
            flex: 1 1 50%
            span
                display: inline-block
                vertical-align: middle
                .searchInputText
                    margin-left: 20px
                    padding: 10px
                    width: 200px
                    &:focus
                        outline: 2px solid $mainColor
                .searchBtn
                    border: 1px solid $mainColor
                    margin: 0 20px 0 10px
                    padding: 12px
                    width: 60px
                    &:hover
                        border: 1px solid $mainColor
                .clearBtn
                    border: 1px solid $mainColor
                    margin: 0
                    padding: 12px
                    width: 100px
                    &:hover
                        border: 1px solid $mainColor
                select
                    margin-left: 15px
                    padding: 10px
                    width: 200px
                .datepicker
                    margin-left: 15px;
    .listHeaderDetail
        color: $grayColor
        display: flex
        font-size: 1.4rem
        margin: 20px 140px 0 140px
        padding: 10px 0
        font-size: 20px
        .headerLeftMenu
            flex: 1 1 50%
            span
                display: inline-block
                vertical-align: middle
                .adDetailData
                    font-weight: 700;
                    margin-right: 20px;
    .mallAdWrapper
        margin: 0 140px
    .mallAdTab
        display: flex
        align-items: flex-end
        gap: 3px
        .mallAdTabBtn
            display: flex
            justify-content: center
            align-items: center
            width: 200px
            height: 30px
            border: none
            background: #C0C0C0
            border-radius: 5px 5px 0 0
            color: #FFF
            font-size: 1.2rem
            cursor: pointer
            &.active
                height: 38px
                background: $grayColor
    .table-container
        max-height: 75vh;
        overflow-y: auto;
    #MallAdTable
        position: relative
        z-index: 1
        width: 100%
        border-collapse: separate
        margin: 0px auto
        white-space: nowrap
        font-size: 1.4rem
        thead
            position: sticky
            top: 0
            width: 100%
            z-index: 2
            th
                position: relative
                background: $grayColor
                border: 1px solid #bbb
                color: $whiteColor
                padding: 10px 5px
                text-align: left
                top: 0
                vertical-align: middle
            .th_sticky_1
                position: sticky
                left: 0
                z-index: 1
                background: none;
                border: none;
                &:before
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 98%;
                    border: 1px solid #bbb
                    background: $grayColor
                    z-index: -1;
            .th_sticky_2
                position: sticky
                left: 0
                z-index: 1
                background: none;
                border: none;
                &:before
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 98%;
                    border: 1px solid #bbb
                    background: $grayColor
                    z-index: -1;
            .th_sticky_3
                position: sticky
                left: 0
                z-index: 1
                background: none;
                border: none;
                &:before
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 98%;
                    border: 1px solid #bbb
                    background: $grayColor
                    z-index: -1;
        tbody
            tr
                background: $whiteColor
                cursor: pointer
            tr:nth-child(odd)
                background: #eee
                .td_sticky_1
                    &:before
                        background: #eee
                .td_sticky_2
                    &:before
                        background: #eee
                .td_sticky_3
                    &:before
                        background: #eee
            tr:nth-child(even)
                background: $whiteColor
                .td_sticky_1
                    &:before
                        background: $whiteColor
                .td_sticky_2
                    &:before
                        background: $whiteColor
                .td_sticky_3
                    &:before
                        background: $whiteColor
            .td_sticky_1
                position: sticky
                left: 0
                z-index: 1
                background: none;
                border: none;
                &:before
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 98%;
                    border: 1px solid #bbb
                    background: inherit
                    z-index: -1;
            .td_sticky_2
                position: sticky
                left: 0
                z-index: 1
                background: none;
                border: none;
                &:before
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 98%;
                    border: 1px solid #bbb
                    background: inherit
                    z-index: -1;
            .td_sticky_3
                position: sticky
                left: 0
                z-index: 1
                background: none;
                border: none;
                &:before
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 98%;
                    border: 1px solid #bbb
                    background: inherit
                    z-index: -1;
        tfoot
            tr
                position: sticky
                bottom: 0
                z-index: 3
                background: $whiteColor
        tr, tr:nth-child(odd)
            &:hover
                background-color: #c8f0e8
        tr, tr:nth-child(even)
            &:hover
                background-color: #c8f0e8
    .selectRoasRow
        color: $grayColor
        position: relative
        td
            border: 1px solid #bbb
            padding: 5px
            text-align: left
        td.price
            text-align: right
        td:nth-child(1), td:nth-child(2), td:nth-child(3)
            text-align: left
        td.stock-link
            cursor: pointer
            text-align: center
            padding: 0
            a
                display: inline-block
                font-weight: 700
                width: 100%
                height: 100%
                color: #02AD90
                text-decoration: underline #02AD90
            a:hover
                color: black
    .ml10
        margin-left: 10px;
@include sp()
    .containerInner
        .listHeader
            display: block
            margin: 20px 0 0 10px
            .headerRightMenu
                margin-top: 20px
        .listHeaderDetail
            margin: 0
            font-size: 18px
        .mallAdWrapper
            margin: 20px 0 0
        #MallAdTable
            thead
                .th_sticky_2
                    position: static
                    background: $grayColor
                    border: 1px solid #bbb
                    &:before
                        content: none;
                        position: static;
                        top: auto;
                        left: auto;
                        width: auto;
                        height: auto;
                        border: none;
                        background: none;
                        z-index: auto;
                .th_sticky_3
                    position: static
                    background: $grayColor
                    border: 1px solid #bbb
                    &:before
                        content: none;
                        position: static;
                        top: auto;
                        left: auto;
                        width: auto;
                        height: auto;
                        border: none;
                        background: none;
                        z-index: auto;
            tbody
                .td_sticky_2
                    position: static
                    border: 1px solid #bbb
                    &:before
                        content: none;
                        position: static;
                        top: auto;
                        left: auto;
                        width: auto;
                        height: auto;
                        border: none;
                        background: none;
                        z-index: auto;
                .td_sticky_3
                    position: static
                    border: 1px solid #bbb
                    &:before
                        content: none;
                        position: static;
                        top: auto;
                        left: auto;
                        width: auto;
                        height: auto;
                        border: none;
                        background: none;
                        z-index: auto;
</style>
